import * as types from '../../constants/log/nftDisassembleLogConstants';

export const nftDisassembleLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
}) => ({
  type: types.NFT_DISASSEMBLE_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
});
